module.exports = __webpack_public_path__ + "static/img/keep_benefit.16a0444f.png";